import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert, Card } from 'react-bootstrap';
import OuvidoriaService from '../../../../services/ouvidoria';
import { Link, Navigate, useParams } from 'react-router-dom';

const FormStatus = () => {
    const [sucesso, setSucesso] = useState(false);
    const [conteudo, setConteudo] = useState("");
    const [anexoTipo, setAnexoTipo] = useState(false);
    const [anexo, setAnexo] = useState([]);
    const [link, setLink] = useState([]);
    const [error, setError] = useState([]);
    const { id } = useParams();

    const handleUpload = (e) => setAnexo(e.target.files[0]);

    const montaForm = async () => {
        const ouvidoria = new FormData();
        ouvidoria.append("conteudo", conteudo)
        ouvidoria.append("anexo", anexo);
        ouvidoria.append("link", link);
        return ouvidoria
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const ouvidoria = await OuvidoriaService.editar(id, dados);
            setSucesso(true)
            setError(false)
            alert("Resposta enviada com sucesso!")
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-12" controlId="Resposta">
                                        <FloatingLabel
                                            label="Sua resposta"
                                            className="mb-12"
                                        >
                                            <Form.Control
                                                required
                                                type="textarea"
                                                name="conteudo"
                                                value={conteudo}
                                                onChange={e => setConteudo(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Form.Group className="mb-3" controlId="anexoTipo">
                                        <Form.Label>Tipo de Anexo</Form.Label>
                                        <Form.Select
                                            required
                                            name="anexoTipo"
                                            onChange={e => setAnexoTipo(e.target.value)}
                                        >
                                            <option>Nenhum</option>
                                            <option value="link">Link</option>
                                            <option value="documento">Documento</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {anexoTipo ?
                                <Col lg={12}>
                                    <Form.Group className="mb-3" controlId="anexo">
                                        <Form.Label>{anexoTipo === "link" ? "Link" : "Documento"}</Form.Label>
                                        {anexoTipo === "link" ? (
                                            <Form.Control
                                                type="text"
                                                name="link"
                                                value={link}
                                                onChange={e => setLink(e.target.value)}
                                            />
                                        ) : (
                                            <Fragment>
                                                <Form.Control
                                                    type="file"
                                                    name="anexo"
                                                    onChange={handleUpload}
                                                    accept=".pdf, .xlsx, .xls"
                                                />
                                            </Fragment>
                                        )}
                                    </Form.Group>
                                </Col> : ''}
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Enviar Requisição</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={'/ouvidoria/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Resposta enviada com sucesso!</Alert>
                <Navigate to={'/ouvidoria/listar'} />
            </Fragment>
        )
    }
}

export default FormStatus